import { Stack, Typography } from '@mui/material';
import * as S from '../../AnomaliesSidebar.styled';
import { AnomalyCardProps } from '../../AnomaliesSidebar.types';
import { StartEndTime } from './StartEndTime';

export function AnomalyCard({
  uuid,
  disabled = false,
  handleOpen,
  title,
  showSuspectPercent = false,
  suspectPercent,
  onSeekChange,
  start,
  end,
}: AnomalyCardProps) {
  return (
    <S.Card variant='outlined' onClick={() => handleOpen(start, end, uuid)} disabled={disabled}>
      <S.CardContentNoPadding smallerPaddings={showSuspectPercent}>
        <Stack direction='row' gap={1} justifyContent='space-between' alignItems='baseline'>
          <Typography fontWeight={600} fontSize={16}>
            {title}
          </Typography>
          {showSuspectPercent && (
            <Typography fontWeight={500}>Suspect: {suspectPercent}</Typography>
          )}
        </Stack>
        <StartEndTime start={start} end={end} onSeekChange={onSeekChange} />
      </S.CardContentNoPadding>
    </S.Card>
  );
}
